// Mirrored from backend/src/domain/workoutLog/executionDocument.js.
// Keep the client from creating documents the frozen server contract rejects.
export const MAX_EXECUTION_ITEMS = 60;
export const MAX_SETS_PER_ITEM = 40;

// Add Exercise appends: max(existing position) + 1 across every item of the
// execution (prescribed and ADDED, performed, unperformed or skipped). Gaps
// left by a removed item are never refilled and existing positions are never
// renumbered. Past the contract ceiling there is no append position, so Add
// Exercise is unavailable.
export function nextExecutionItemPosition(record) {
  const items = record?.document?.items || [];
  if (items.length >= MAX_EXECUTION_ITEMS) return null;
  const positions = items
    .map((item) => item.position)
    .filter((value) => Number.isInteger(value));
  const next = Math.max(0, ...positions) + 1;
  return next <= MAX_EXECUTION_ITEMS ? next : null;
}

// Add Set appends: max(existing setIndex) + 1 across every set of the item
// (prescribed and ADDED, performed or not). Gaps are never refilled and
// existing indices are never renumbered. Past the contract ceiling there is
// no append position, so Add Set is unavailable.
export function nextExecutionSetIndex(item) {
  const sets = item?.sets || [];
  if (sets.length >= MAX_SETS_PER_ITEM) return null;
  const indices = sets
    .map((set) => set.setIndex)
    .filter((value) => Number.isInteger(value));
  const next = Math.max(0, ...indices) + 1;
  return next <= MAX_SETS_PER_ITEM ? next : null;
}
